import { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useNavigate, useSearchParams } from "react-router-dom";
import { Alert, AlertIcon, Link, Spinner, Stack, Text } from "@chakra-ui/react";
import { authApi } from "../api/authApi";
import { useAuth } from "../hooks/useAuth";
import { trackEvent } from "../../../shared/lib/analytics";
import { lerVerificadorGoogle, limparVerificadorGoogle } from "../lib/googleVerifier";

// Destino do "Entrar com Google": o backend redireciona para cá com um código de uso
// único, trocado aqui pela sessão (o JWT nunca passa pela URL) junto com o verificador
// guardado no sessionStorage quando o botão foi clicado.
export default function GoogleCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [erro, setErro] = useState(null);
  // o código só pode ser trocado uma vez — evita a segunda chamada do StrictMode
  const trocado = useRef(false);

  useEffect(() => {
    if (trocado.current) return;
    trocado.current = true;

    const code = searchParams.get("code");
    const verifier = lerVerificadorGoogle();
    if (!code) {
      setErro("Link de login inválido.");
      return;
    }
    if (!verifier) {
      // o código só vale no navegador (e na aba) em que o login com Google começou
      setErro("Abra o login com Google nesta mesma aba e tente novamente.");
      return;
    }
    authApi
      .googleExchange(code, verifier)
      .then((data) => {
        limparVerificadorGoogle();
        login(data);
        trackEvent("login", { metodo: "google" });
        navigate("/dashboard", { replace: true });
      })
      .catch(() => setErro("Não foi possível concluir o login com Google. Tente novamente."));
  }, [searchParams, login, navigate]);

  if (erro) {
    return (
      <Stack spacing={4}>
        <Alert status="error" borderRadius="md" fontSize="sm">
          <AlertIcon />
          {erro}
        </Alert>
        <Link as={RouterLink} to="/auth/login" color="accent-text" textAlign="center" fontSize="sm">
          Voltar para o login
        </Link>
      </Stack>
    );
  }

  return (
    <Stack spacing={3} align="center" py={6}>
      <Spinner />
      <Text fontSize="sm" color="app-muted-fg">
        Entrando com Google…
      </Text>
    </Stack>
  );
}
